import { render } from "./BaseSearchInput.vue?vue&type=template&id=2f750550&ts=true"
import script from "./BaseSearchInput.vue?vue&type=script&lang=ts"
export * from "./BaseSearchInput.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__